export enum ModeType {
    Create = 'create',
    Request = 'request',
    Edit = 'edit',
    Copy = 'copy',
    Accept = 'accept',
}